/*jshint forin:true, noarg:true, noempty:true, eqeqeq:true, bitwise:true, strict:true, undef:true, unused:true, browser:true, devel:true, jquery:true, indent:4, maxerr:50, boss:true, trailing:true, white:true, sub:true */
/* eslint no-console: ["error", { allow: ["warn", "error", "log"] }]*/
/* global jQuery, console, Power4, console, Power0, TimelineMax, TweenMax, window, jQuery */
/*
* jQuery Estee Lauder Carousel Plugin
*              ___
*        _____|| ||_____     *BEEP BOOP*
*        | o  |___|  o |
*        |   [(===)]   |
*        |_____| |_____|
*   ___  ____//\_/\\____  ___
*  |   | |_|___\_/___|_| |   |
* [|   |]| |===      | |[|   |]
*  |___| |_|o_______o|_| |___|
*   \ |    \|_______|/    | /
*  _|_|_    [__|_|__]    _|_|_
*  |___|      |___|      |___|
*  |   |       | |       |   |
*             [| |]
*/

/**
* A jQuery plugin to create, populate, and control a horizontal carousel. This plugin also assumes that the DOM has already been properly set up and stylized; the only changes are the addition of dynamically created slides (if needed).
* @version 1.0.3
* @author Aric Ng
*
* 0.0.6
*  - Removed event bindings from options (better handled outside of this plugin)
*  - Added update and carouselUpdate function to handle added/removed/new slides
*  - Removed any vanilla class markers
*  - Added $.fn.each functionality in plugin functions so that all elements in the selector are affected
*
* 0.0.7
* - Added previous carousel functionality for backwards compatibility
*
* 1.0.0
* - Complete overhaul of script
*
* 1.0.1
* - Switch to using transforms
*
* 1.0.2
* - Added Slide and Dot "active" class options
* - Fixed a bug when reversing carousel without clones
*
* 1.0.3
* - Modified update function to work with slides that may have been dynamically added to the carousel
*/

(function($) {
  'use strict';

  /**
  * @function Carousel
  * @description Handles virtual element progression and display of said progression via CSS position (top, left, right, bottom) changes
  * @param {jQuery} $target jQuery selector representing the target element to make into a Carousel
  * @param {object} options Various modifiers to modify carousel functionality
  * @returns {Carousel} A Carousel instance
  */
  var Carousel = function Carousel($target, options) {

    var defaults = {
      callbackAnimationNext: false,      // Animation override for next progression
      callbackAnimationPrev: false,      // Animation override for prev progression
      callbackAnimation: false,        // Global animation override for progression
      callbackAnimationOptions : {
        duration: undefined,
        callback: undefined
      },
      callback: false,           // Callback for progression completion
      vertical: false,           // For layout being vertical or not
      increment: '100%',         // spacing between slides (assumes all are equal size and this is the measurement units desired)
      offset: '0%',          // Offset slides from left of carousel
      ignoreTargets: ':hidden',    // Must be valid selector values, used to ignore slides for processing, by default hidden elements are not visible
      activeOffset: 0,           // Offsets the active slide position (TODO)
      maxSlides: -1,         // Represents the maximum amount of slides on carousel at a time -1 for infinite
      minSlides: -1,         // Represents the minimum amount of slides in the carousel for progression to happen, -1 for no minimum
      callbackInit: false,
      duration: undefined,                 // Animation Duration (old); this will get plugged into callbackAnimationOptions
      debug: false,
      slideActiveClass: 'active',
      dotActiveClass: 'active'
    };
    var increment = 0;
    var offset = 0;
    var _this = this;
    var debug = defaults.debug;

    options = $.extend(defaults, options);
    this.optionVars = options; // Save original option values

    this.debug = options.debug;
    debug = this.debug;

    // Must have a jQuery selector
    if (typeof $target === 'undefined' || $target.length === 0 || !($target instanceof jQuery)) {

      if (debug) {
        console.log('%cCarousel not created: ', Carousel.consoleStyle, $target, options);
      }
      return;
    }

    // Set animation callbacks
    this.callbackAnimations = {
      next: options.callbackAnimationNext,   // Callback for when the carousel progresses "forwards"
      prev: options.callbackAnimationPrev,   // Callback for when the carousel  progresses "backwards"
      update: (function() {                        // Global callback for when a carousel progresses either way
        if (options.useGSAP && typeof Carousel.progression.animateSlidesBasic === 'function') {
          return Carousel.progression.animateSlidesBasic;
        } else {
          return  options.callbackAnimation;
        }
      }()),
      // Set animation callback modifiers
      options: options.callbackAnimationOptions // Modifiers to be passed to animation callback
    };

    // Handler for old duration option value
    this.callbackAnimations.options.duration = (function() {

      if (typeof options.duration === 'number') {
        return options.duration;
      } else if (typeof options.callbackAnimationOptions !== 'undefined' && typeof options.callbackAnimationOptions.duration === 'number') {
        return options.callbackAnimationOptions.duration;
      }

      return 0;

    }());

    // Handler for default ease if (old) useGSAP is defined in options
    this.callbackAnimations.options.ease = (function() {
      if (typeof options.useGSAP !== 'undefined' && options.useGSAP) {
        return Power4.easeOut;
      }

      return;
    }());

    this.$target = $target;

    // Slide handling
    slide_handling : {

      this.ignoreTargets = options.ignoreTargets; // Slides to ignore
      this.slides = []; // This is used to determine slide order
      this.$slides = $target.children().not(this.ignoreTargets); // Slides that fall on ignoreTargets do not get positioned or added to the this.slides array
      this.maxSlides = options.maxSlides;
      this.minSlides = options.minSlides;
      this.vertical = options.vertical;
      this.slideActiveClass = options.slideActiveClass;
      this.dotActiveClass = options.dotActiveClass;

      // process increment for % or px
      increment = options.increment;
      offset = options.offset;

      // Get increment and unit, this assumes the units are valid
      if (/^[0-9]+(?:\.[0-9]+)?([A-z]+|%)/.test(increment)) {
        this.unit = /([A-z]+|%)/.exec(increment)[0];
        this.increment = parseFloat(increment.replace(this.unit, ''));
        this.offset = parseFloat(offset.replace(this.unit, ''));

        if (debug) {
          console.log('%cCarousel: Using unit ' + this.unit + ' with increment ' + increment, Carousel.consoleStyle);
        }

      } else {

        if (debug) {
          console.log('%cCarousel not created: Invalid increment: ' + increment, Carousel.consoleStyle);
        }
        return;
      }

      // Initial slides are ordered by DOM order
      this.$slides.each(function() {
        var $this = $(this);
        _this.slides.push($this);
      });

      this.oldSlides = this.slides.slice(0);

    }

    // Init slide positions by running a 0 step slide progression
    if (typeof this.callbackAnimations.update === 'function') {
      this.callbackAnimations.update.apply(this, [1, 0, {duration: 0}]);
    } else {
      this.step(0, {noAnimation: true, override: true});
    }

    // Post setup callback
    if (typeof options.callbackInit === 'function') {

      options.callbackInit.apply(this);
    }

    if (debug) {
      console.log('%cCarousel: Created: ', Carousel.consoleStyle, $target, options);
    }
    return this;

  };

  Carousel.prototype = {
    /**
    * @function step
    * @description Steps through slides
    * @param {number} steps - Amount of slides to step through
    * @returns {undefined|jQuery} Undefined if steps is undefined or 0, otherwise a jquery selector representing the current slide
    */
    step: function(steps, options) {
      var defaults = {
        noAnimation: false,
        override: false
      };
      var dir;
      var slide;
      var $slide;
      var s = 0;
      var slideData = [];
      var increment = this.increment; // Set this to pass to animation callbacks
      var callbackAnimations = this.callbackAnimations;

      if (typeof this.animationTimeline !== 'undefined') {
        return;
      }

      this.oldSlides = this.slides.slice(0); // Duplicate old slides

      options = $.extend(defaults, options);

      // Must have steps, steps must not be 0, and slide count has to be greater than minimum slides
      if (!options.override && (typeof steps === 'undefined' || steps === 0 || (this.slides.length < this.minSlides && this.minSlides !== -1))) {
        return;
      }

      // Determine direction 1 is forwards (next), -1 is backwards (prev)
      dir = steps > 0 ? 1 : (steps < 0 ? -1 : 0);

      steps = Math.abs(steps);

      // Must be a non-zero number
      if (dir === 0 && !options.override) {
        return;
      }

      // Reorder slides in array; this does not affect slide positions in DOM
      for (s = 0; s < steps; s++) {
        if (dir > 0) {
          slide = this.slides.shift();
          this.slides.push(slide);
        } else if (dir < 0) {
          slide = this.slides.pop();
          this.slides.unshift(slide);
        }

      }

      // Build array for updated positions to be animated to
      if (((dir > 0 && callbackAnimations.next !== false) || (dir < 0 && callbackAnimations.prev !== false)) && !options.noAnimation) {

        for (s = 0; s < this.slides.length; s++) {

          $slide = this.slides[s];
          slideData.push({$slide: $slide, position: increment*s, unit: this.unit});

        }

      }

      // Animation stuff here
      // Visual looping is handled outside of the script
      if (dir > 0 && typeof callbackAnimations.next === 'function' && !options.noAnimation) {

        callbackAnimations.next.apply(this, [dir, steps, callbackAnimations.options]);

      } else if (dir < 0 && typeof callbackAnimations.prev === 'function' && !options.noAnimation) {

        callbackAnimations.prev.apply(this, [dir, steps, callbackAnimations.options]);
      }
      // Global animation callback
      else if (typeof callbackAnimations.update === 'function' && !options.noAnimation) {

        callbackAnimations.update.apply(this, [dir, steps, callbackAnimations.options]);

      }

      // Reposition slides by array order
      if (options.noAnimation || (typeof callbackAnimations.next !== 'function' && typeof callbackAnimations.prev !== 'function' && typeof callbackAnimations.update !== 'function')) {
        for (s = 0; s < this.slides.length; s++) {

          $slide = this.slides[s];
          $slide.css(this.vertical ? 'top' : 'left', increment*s+this.unit);

        }

      }

    },
    /**
    * @function stepTo
    * @description Jumps to a target index relative to the DOM
    * @param {number} index - Child index to jump to
    * @returns {jQuery} Slide jumped to
    */
    stepTo: function(index) {
      var $targetSlide;
      var s = 0;
      var steps;

      if (typeof index !== 'number' || index < 0 || index >= this.slides.length) {
        return;
      }

      $targetSlide = this.$slides.eq(index);

      if ($targetSlide.length === 0) {
        return;
      }

      // Find thingy's current position in array (costly)
      // This will get positive steps a direction
      for (s = 0; s < this.slides.length; s++) {
        if (this.slides[s].is($targetSlide)) {
          break;
        }
      }

      steps = s;

      // Check if distance to other side is shorter
      if (this.slides.length-steps < steps) {
        steps = steps-this.slides.length; // For negative
      }

      // Get steps
      // Pass to instance's step function (where progression will be handled)
      this.step(steps);

      return $targetSlide;
    },
    /**
    * @function update
    * @description Reads current DOM and updates slides with changes
    * @returns {undefined} This function does not return anything
    */
    update: function(options) {
      var $currActive = $(this.slides[0]); // Save the current active slide
      var increment;
      var _this = this;
      var i = 0;
      var stepTarget = 0;
      var hasCallbackAnimation = typeof this.callbackAnimations.update === 'function';

      // If option argument has been set update options
      if (typeof options !== 'undefined') {
        options = $(this.optionVars, options);

        // Update vertical
        if (options.vertical !== this.optionVars.vertical) {
          this.vertical = options.vertical;
        }

        // Update ignoreTargets
        if (options.ignoreTargets !== this.optionVars.ignoreTargets) {
          this.ignoreTargets = options.ignoreTargets;
        }

        // Update increment
        // Get units too
        if (options.increment !== this.optionVars.increment) {

          increment = options.increment;

          // Get increment and unit, this assumes the units are valid
          if (/^[0-9]+[\.[0-9]+]?%/.test(increment)) {
            this.unit = '%';
            this.increment = parseInt(increment.replace(this.unit, ''));
          } else if (/^[0-9]+(?:\.[0-9]+)?[A-z]+/.test(increment)) {
            this.unit = /[A-z]+/.exec(increment)[0];
            this.increment = parseInt(increment.replace(this.unit, ''));
          }

        }

        this.optionVars = options;
      }

      this.$slides.css(this.vertical ? 'top' : 'left', ''); // clear increments

      // Reset and rebuild
      this.slides = [];
      this.$slides = this.$target.children().not(this.ignoreTargets); // Look for children not on the ignore list

      // Make sure the currently active slide is not one of the ignore targets, otherwise iterate backwards until $currActive is a non-ignored slide
      while ($currActive.is(this.ignoreTargets) && $currActive.length !== 0) {

        $currActive = $currActive.prev();

      }

      // Initial slides are ordered by DOM order
      // Also, find the previously active slide...
      this.$slides.each(function() {
        var $this = $(this);

        // Only run if there is no callback animation
        if (!hasCallbackAnimation) {
          if ($this.is($currActive)) {
            stepTarget = i;
          }

          $this.css(_this.vertical ? 'top' : 'left', _this.increment*i+_this.unit);
          i++;
        }

        _this.slides.push($this);
      });

       // Use animation callback to reorder slides
      if (hasCallbackAnimation) {
        this.callbackAnimations.update.apply(this, [1, 0, {duration: 0}]);
      }
      // Update w/offset w/o animation
      else {
        this.step(stepTarget, {noAnimation: true});
      }

    }
  };

  Carousel.consoleStyle = 'color: #8b8e89; font-size: 15px; font-family: Arial;';

  /* Carousel Progression Stuff*/
  // Almost feels like this stuff should be instanced as well
  // However it's starting to be apparent that callback animations have to handle themselves very much outside of the carousel script
  // Since progression can outpace animation
  Carousel.progression = {
    animateSlidesBasic: function(dir, steps, options) {
      var _this = this;
      var defaults = {
        callback: undefined,
        ease: Power0.easeNone,
        useClones: true,
        debug: false
      };
      var slides = this.slides;
      var increment = this.increment;
      var offset = this.offset;
      var unit = this.unit;
      var s;
      var $slide;
      var $cloneSlide;
      var ease = Power0.easeNone;
      var duration = 1;
      var callback;
      var useClones;
      var debug = false;

      options = $.extend(defaults, options);

      if (typeof options !== 'undefined') {
        duration = options.duration;
        callback = options.callback;
        ease = options.ease;
        useClones = options.useClones;
        debug = typeof options.debug !== undefined ? options.debug : debug;

      }

      if (typeof TimelineMax === 'undefined' || typeof this.animationTimeline !== 'undefined' || _this.$slides.length === 0) {
        if (debug) {
          console.log('rejected');
        }

        return;
      }

      if (steps !== 0) {
        _this.oldSlides[0].trigger('slideWillLoseActive'); // Signal that the last slide will lose active after animation
      }

      _this.slides[0].trigger('slideWillGainActive');    // Signal that the first slide will gain active after animation

      var adjustedIncrement = (((_this.$target.width() * (increment / 100)) - $(_this.slides[0]).outerWidth()) / $(_this.slides[0]).outerWidth()) * 100;
      var adjustedOffset = ((_this.$target.width() * (offset/100)) / $(_this.slides[0]).width()) * 100;

      this.animationTimeline = new TimelineMax({
        paused: true,
        onComplete: function() {
          _this.animationTimeline = undefined;

          // Remove clones
          _this.$target.find('.carousel_clone').remove();

          // Position all slides
          for (s = 0; s < _this.slides.length; s++) {
            $slide = _this.slides[s];
            TweenMax.set($slide, {x: ((100 + adjustedIncrement) * s) + (adjustedOffset) + unit});
          }

          // Signal first slide has gained active
          // Mark first slide as active
          _this.slides[0].trigger('slideHasGainedActive');
          _this.slides[0].addClass(_this.slideActiveClass).siblings().removeClass(_this.slideActiveClass);

          // Signal that last slide has gained active
          if (steps !== 0) {
            _this.oldSlides[0].trigger('slideHasLostActive');
          }

          // Signal overall carousel updated
          _this.$target.trigger('carousel_updated', _this.slides[0].index());

          if (typeof callback === 'function') {
            callback();
          }
        }
      });

      // Create clones
      // If steps is greater than slides loop around (allowing for huge steps)

      if (typeof useClones !== 'undefined' && useClones) {
        for (s = (dir === 1 ? 0 : steps); (dir === 1 ? s < steps : s >= 1); (dir === 1 ? s++ : s--)) {
          var test = s % slides.length;

          test = dir === 1 ? test : (slides.length-test)-(test === 0 ? 1 : 0);
          $slide = this.oldSlides[test];
          $cloneSlide = $slide.clone().addClass('carousel_clone');

          this.$target.trigger('carouselCloneCreated', $cloneSlide);

          if (dir === 1) {

            this.$target.append($cloneSlide);
            TweenMax.set($cloneSlide, {x: (((slides.length + s) * (100 + adjustedIncrement)) + adjustedOffset) + unit});

          } else if (dir === -1) {

            this.$target.prepend($cloneSlide);
            TweenMax.set($cloneSlide, {x: (((100 + adjustedIncrement) * -s) + adjustedOffset) + unit});

          }
        }

      } else {
        if (dir === -1) {
          // Position all slides
          for (s = 0; s < _this.slides.length; s++) {
            $slide = _this.slides[s];
            this.animationTimeline.set($slide, {x: ((100 + adjustedIncrement) * (s - steps)) + (adjustedOffset) + unit});
          }
        }
      }

      this.animationTimeline.to(this.$target.children(), duration, {
        x: '+='+ ((-dir * (100 + adjustedIncrement) * steps)) + unit,
        ease: ease
      });

      this.animationTimeline.play();
    }
  };

  ///////////////////////////
  ///////// BEGIN: jQuery Plugin
  ///////////////////////////
  $.fn.elCarousel = function(options) {
    var $this = $(this);
    var elCarousel;
    var $dotContainer;
    var $dotTemplate;
    var $dots;
    var $dotClone;
    var dotIncrement = 0;

    $this.each(function() {
      var $this = $(this);
      elCarousel = new Carousel($this, options);
      $this.data('elCarousel', elCarousel);
    });

    // Legacy functionality
    if (typeof options !== 'undefined') {

      ////////////////////////////////////
      // BEGIN: Dot Container
      ////////////////////////////////////

      $dotContainer = options.$dot_container;
      $dotTemplate = options.$dot_template;

      // Must have both a dot container and a dot template to work
      if (typeof $dotContainer !== 'undefined' && typeof $dotTemplate !== 'undefined') {

        // Remove all dot navs that aren't template
        $dotContainer.children().not($dotTemplate).remove();

        $dots = $();
        // Clone dots for the amount of slides in carousel
        for (dotIncrement = 0; dotIncrement < $this.children().length; dotIncrement++) {
          $dotClone = $dotTemplate.clone().removeClass('template');
          $dotContainer.append($dotClone);
          $dots = $dots.add($dotClone);
          if (dotIncrement === 0) {
            $dotClone.addClass(elCarousel.dotActiveClass);
          }
        }

        $dotContainer.off('click').on('click', function(e) {
          var $target = $(e.target);
          e.preventDefault();

          $target.addClass(elCarousel.slideActiveClass).siblings().removeClass(elCarousel.slideActiveClass);

        });

// Will need to implement this event(?)
        $(window).off('carousel_updated').on('carousel_updated', function(e, index) {
          $dots.eq(index).addClass(elCarousel.dotActiveClass).siblings().removeClass(elCarousel.dotActiveClass);
        });
      }
      ////////////////////////////////////
      // END: Dot Container
      ////////////////////////////////////
    }

  };

  $.fn.elCarouselNext = function(steps) {
    var $this = $(this);

    if (typeof steps === 'undefined') {
      steps = 1;
    }

    $this.each(function() {
      var $this = $(this),
      carouselData = $this.data('elCarousel');

      if (typeof carouselData !== 'undefined') {
        carouselData.step(steps);
      }
    });

    return $this;
  };

  $.fn.elCarouselPrev = function(steps) {
    var $this = $(this);

    if (typeof steps === 'undefined') {
      steps = -1;
    }

    $this.each(function() {
      var $this = $(this),
      carouselData = $this.data('elCarousel');

      if (typeof carouselData !== 'undefined') {
        carouselData.step(steps);
      }
    });

    return $this;
  };

  $.fn.elCarouselTo = function(index) {
    var $this = $(this);

    $this.each(function() {
      var $this = $(this),
      carouselData = $this.data('elCarousel');

      if (typeof carouselData !== 'undefined') {
        carouselData.stepTo(index);
      }
    });

    return $this;
  };

  $.fn.elCarouselDestroy = function() {
    $(this).removeData('elCarousel');

    return $(this);
  };

  $.fn.elCarouselUpdate = function(callback) {
    var $this = $(this);

    $this.each(function() {
      var $this = $(this),
      carouselData = $this.data('elCarousel');

      if (typeof carouselData !== 'undefined') {
        carouselData.update();
      }

      // Run post update callback
      if (typeof callback !== 'undefined') {
        callback.apply(carouselData, [0, 0]);
      }
    });

    return $this;
  };

  $.elCarouselgetStandardAnimationCallbacks = function() {
    return Carousel.progression;
  };

  // Legacy function handling
  $.fn.el_carousel = $.fn.elCarousel;

  // Disable event on external script instead
  $.fn.setDisableCarouselControls = function() {};
  $.fn.carouselSetEnabled = function() {};
  $.fn.enableDisableCarousel = jQuery.fn.carouselSetEnabled;

  $.fn.carouselPrev = $.fn.elCarouselPrev;
  $.fn.carouselNext = $.fn.elCarouselNext;
  $.fn.carouselTo = $.fn.elCarouselTo;

  $.fn.carouselDestroy = $.fn.elCarouselDestroy;
  $.fn.carouselUpdate = $.fn.elCarouselUpdate;

  $.fn.carouselGetSlides = function() {};

})(jQuery);
